<template>
  <b-modal
    id="confirm-action--modal"
    hide-footer
    hide-header
    modal-class="success-popup success-popup_wrong"
    no-fade
  >
    <div class="text-center modal-complete">
      <svg class="icon icon-icon-popup-wrong">
        <use xlink:href="#icon-icon-popup-wrong" />
      </svg>

      <h2>
        {{ modal.title }}
      </h2>

      <div class="popup-meta">
        {{ modal.text }}
      </div>

      <div class="d-flex justify-content-center align-items-center">
        <b-button
          variant="outline-primary"
          class="w-100 m-3"
          @click="confirmAction"
        >
          <!-- TODO: need to add translation -->
          {{ modal.confirmActionText }}
        </b-button>
        <b-button
          variant="outline-primary"
          @click="$bvModal.hide('confirm-action--modal')"
        >
          {{ $t('errorpopup.close') }}
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
  export default {
    name: "ConfirmActionModal",
    props: {
      modal: {
        type: Object,
        required: true
      }
    },
    methods: {
      confirmAction() {
        this.$emit('confirm-action', true);
      }
    }
  }
</script>

<style scoped>

</style>
